import { baseUrl } from '../../config/clientsConfig'
import axios from "axios";

const ReAssignLead= {
getReAssignCount: async (reqData)=> axios.post(`${baseUrl}/leads/reAssignLeadCount`, reqData),
resignSingleLead: async (reqData) =>
    axios.post(`${baseUrl}/leads/reassign-one-lead`, reqData),
resignBulkLead : async (reqData) =>
    axios.post(`${baseUrl}/leads/bulkReAssignLead`, reqData),
}


export default ReAssignLead;